export const STAT_LIMITS = [
    { suffix: "Size", stat: "Silhouette", label: "Silhouette", types: ["Vehicle", "Mount"] },
    { suffix: "EncumCap", stat: "EncumbranceCapacity", label: "Encumbrance Capacity", types: ["Vehicle", "Mount"] },
    { suffix: "Enc", stat: "Encumbrance", label: "Encumbrance", types: ["Weapon", "Armor", "Gear"] },
    { suffix: "Soak", stat: "Soak", label: "Soak", types: ["Armor"] },
    { suffix: "Defense", stat: "Defense", label: "Defense", types: ["Armor"] },
]

export const limitsForType = (type) => STAT_LIMITS.filter((l) => l.types.includes(type))

const isSet = (v) => v !== undefined && v !== null && v !== "" && !isNaN(parseInt(v))

export const meetsStatLimits = (attachment, item) => STAT_LIMITS.every(({ suffix, stat }) => {
    const min = attachment["Min" + suffix]
    const max = attachment["Max" + suffix]
    if (!isSet(min) && !isSet(max)) return true
    const value = parseInt(item?.[stat]) || 0
    return (!isSet(min) || value >= parseInt(min)) && (!isSet(max) || value <= parseInt(max))
})

export const statLimitText = (attachment) => STAT_LIMITS.map(({ suffix, label }) => {
    const min = attachment["Min" + suffix]
    const max = attachment["Max" + suffix]
    if (isSet(min) && isSet(max)) return `${label} ${min}–${max}`
    if (isSet(min)) return `${label} ${min}+`
    if (isSet(max)) return `${label} ${max} or less`
    return null
}).filter(Boolean).join(", ")
